import { isWeb } from "@medbillai/ui";

/** The frosted plate intake heroes lay over a photo. */
export const GLASS_FILL = "rgba(255, 255, 255, 0.14)";
export const GLASS_STROKE = "rgba(255, 255, 255, 0.25)";

export const GLASS_BLUR = isWeb
  ? { backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }
  : undefined;
